import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetEmailSent, setResetEmailSent] = useState(false);
  const [showResetForm, setShowResetForm] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const { login, resetPassword } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    if (!email || !password) {
      return setError('Inserisci email e password');
    }

    try {
      setError('');
      setLoading(true);
      const result = await login(email, password);
      
      if (result.role === 'admin') {
        navigate('/admin');
      } else if (result.role === 'dipendente') {
        navigate('/dipendente');
      }
    } catch (err) {
      setError('Login fallito: ' + err.message);
    }
    
    setLoading(false);
  }

  async function handlePasswordReset() {
    if (!resetEmail) {
      return setError('Inserisci la tua email per recuperare la password');
    }

    try {
      setError('');
      setLoading(true);
      
      await resetPassword(resetEmail);
      setResetEmailSent(true);
      
    } catch (err) {
      if (err.code === 'auth/user-not-found') {
        setError('❌ Email non registrata nel sistema');
      } else if (err.code === 'auth/invalid-email') {
        setError('❌ Formato email non valido');
      } else {
        setError('Errore invio email: ' + err.message);
      }
    }
    setLoading(false);
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <h1><img src="/CRG_logo.png" alt="crg" style={{ width: '250px' }} /></h1>
        <h2>Login</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        {showResetForm ? (
          // ========== FORM RESET PASSWORD ==========
          <div>
            <h3>Recupero Password</h3>

            {resetEmailSent ? (
              <div>
                <p style={{ color: '#27ae60', marginTop: '15px', fontSize: '14px' }}>
                  ✅ Email di recupero inviata! Controlla la tua casella.
                </p>
                <button
                  onClick={() => {
                    setShowResetForm(false);
                    setResetEmailSent(false);
                    setResetEmail('');
                    setError('');
                  }}
                  className="btn-primary"
                >
                  ← Torna al Login
                </button>
              </div>
            ) : (
              <div>
                <div className="form-group">
                  <input
                    type="email"
                    value={resetEmail}
                    onChange={(e) => setResetEmail(e.target.value)}
                    placeholder="inserisci email"
                    disabled={loading}
                  />
                </div>

                <button
                  onClick={handlePasswordReset}
                  disabled={loading}
                  className="btn-primary"
                >
                  {loading ? 'Invio in corso...' : 'Invia Reset Password'}
                </button>

                <button
                  type="button"
                  onClick={() => {
                    setShowResetForm(false);
                    setResetEmail('');
                    setError('');
                  }}
                  disabled={loading}
                  style={{
                    background: 'transparent',
                    color: '#b52c24',
                    border: 'none',
                    marginTop: '15px',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontSize: '14px'
                  }}
                >
                  ← Annulla
                </button>
              </div>
            )}
          </div>
        ) : (
          // ========== FORM LOGIN NORMALE ==========
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="inserisci email"
                disabled={loading}
              />
            </div>
            
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="inserisci password"
                disabled={loading}
              />
            </div>
            
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Accesso in corso...' : 'Accedi'}
            </button>

            <button
              type="button"
              onClick={() => {
                setShowResetForm(true);
                setError('');
              }}
              disabled={loading}
              style={{
                background: 'transparent',
                color: '#ae2722',
                border: 'none',
                marginTop: '15px',
                cursor: 'pointer',
                textDecoration: 'underline',
                fontSize: '14px'
              }}
            >
              🔑 Password dimenticata?
            </button>
	   <p>v{process.env.REACT_APP_VERSION || '—'}</p>
          </form>
        )}
      </div>
    </div>
  );
}

export default Login;
